import { utagLinkSortSearch } from 'features/tealium';

import getSearchUrl from '../getSearchUrl';

import redirectToCategorySearch from './redirectToCategorySearch';

function doCategorySearch (query, category) {

	if (query) {

		utagLinkSortSearch(query);
		const searchUrl = getSearchUrl(query);
		redirectToCategorySearch(searchUrl, category);

	}

}

export default doCategorySearch;
